import { SvgClose, TextButton } from '@loomhq/lens';
import React, { Component } from 'react';

class CancelTrimButton extends Component {
  render() {
    const { currentTrimRange } = this.props;

    const canCancelTrim = currentTrimRange != null;
    const cancelTrimOnClick = canCancelTrim
      ? this.props.onCancelCurrentTrimRange
      : null;

    return (
      <TextButton
        icon={<SvgClose />}
        isDisabled={!canCancelTrim}
        onClick={cancelTrimOnClick}
      >
        Cancel
      </TextButton>
    );
  }
}

export default CancelTrimButton;
